import { type AiNotification } from 'clients/CallhomeApiTypes';
import useCallhomeClient from 'src/hooks/useCallhomeClient';
import useSWR from 'swr';

export default function useAiNotifications() {
  const callhomeClient = useCallhomeClient();

  const aiNotifications = useSWR('all-ai-notifications', () => {
    return callhomeClient.getAiNotifications();
  });

  const getAiNotification = (id: string) => {
    return (aiNotifications.data ?? []).find((value) => value.id === id);
  };

  const createAiNotification = async (data: AiNotification) => {
    const result = await callhomeClient.postAiNotification(data);
    const newAiNotifications = [result, ...(aiNotifications.data ?? [])];
    aiNotifications.mutate(newAiNotifications);
    return result;
  };

  const updateAiNotification = async (id: string, data: Partial<AiNotification>) => {
    const result = await callhomeClient.updateAiNotification(id, data);
    const newAiNotifications = aiNotifications.data?.map((aiNotification) =>
      aiNotification.id === id ? result : aiNotification,
    );
    aiNotifications.mutate(newAiNotifications);
    return result;
  };

  const deleteAiNotification = async (id: string) => {
    const result = await callhomeClient.deleteAiNotification(id);
    const newAiNotifications = (aiNotifications.data ?? []).filter((value) => value.id !== id);
    aiNotifications.mutate(newAiNotifications);
    return result;
  };

  return {
    ...aiNotifications,
    getAiNotification,
    createAiNotification,
    updateAiNotification,
    deleteAiNotification,
  };
}

export type CategorizedEventSpotChecks = Record<string, AiNotification[]>;

export function useCategorizedEventSpotChecks() {
  const aiNotifications = useAiNotifications();

  return { active: aiNotifications.data ?? [] } as CategorizedEventSpotChecks;
}
